import axios from '../../common/utils/interceptor';
import updateTaskItem from '../utils/updateTaskItem';
import { apiUrls, routeMappings, SessionStore } from '../../constants';
import { ASSESSMENT_EVALUATION_POLLING_TIME, TaskItemStatus } from '../constants';
import { markWorkflowEnd } from '../utils/markWorkflowEnd';
import { Task } from '../interfaces';
import { useBasicDetails } from '../../store';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

/**
 * Polling for Evaluation pending Task item
 */
export const usePollPendingAssessmentItem = (tasks: Task[]): void => {
  const history = useHistory();
  const { updateCurrentWorkflowItem } = useBasicDetails();
  const lastPendingTaskIndex = tasks.findIndex((task: Task) => task.status === TaskItemStatus.EVALUATION_PENDING);

  useEffect(() => {
    const pendingTask = tasks[lastPendingTaskIndex];
    const pendingItem = pendingTask && pendingTask.items.find((i) => i.status === TaskItemStatus.EVALUATION_PENDING);
    if (pendingItem) {
      const itemStatusIntervalId: ReturnType<typeof setInterval> = setInterval(async () => {
        const { data } = await axios.get(`${apiUrls.INITIALIZE_TASK}/${pendingItem.id}`);

        if (data && data.status !== TaskItemStatus.EVALUATION_PENDING) {
          clearInterval(itemStatusIntervalId);
          if (data.status === TaskItemStatus.HURDLE_FAILED) {
            updateTaskItem({ ...pendingItem, taskId: pendingTask.id }, TaskItemStatus.HURDLE_FAILED);
            await markWorkflowEnd();
            // const path = feedbackPage && feedbackPage.enabled ? 'VIDEO_FEEDBACK' : 'TASKLIST_HURDLE_FAIL';
            history.push(routeMappings['TASKLIST_HURDLE_FAIL']);
          } else {
            updateTaskItem({ ...pendingItem, taskId: pendingTask.id }, TaskItemStatus.COMPLETED);
            const currentWorkflowItem = sessionStorage.getItem(SessionStore.currentWorkflowItem);
            if (currentWorkflowItem) updateCurrentWorkflowItem(JSON.parse(currentWorkflowItem));
          }
        }
      }, ASSESSMENT_EVALUATION_POLLING_TIME);

      return (): void => clearInterval(itemStatusIntervalId);
    }
  }, [tasks, lastPendingTaskIndex, updateCurrentWorkflowItem, history]);
};
